import StickySidebar from 'sticky-sidebar-v2';

class tarotGame {
    attributes = {};
    cardCurrent = 0;
    width = 15; //card width in percents
    game = null; //game container
    result = null; //result container
    tirage = null; //tirage container
    collapsedElement = null; //collapsed element container
    cardsRow = null; //cards row element
    cardsSelected = []; //selected cards
    cards = null; //card elements
    optionBtns = null; //option btns
    optionContainer = null; //option container
    preloader = null; //preloader for the transition between game and result pages

    constructor(game) {
        if (!game) {
            return;
        }

        try {
            this.game = game;
            this.game.style.opacity = 1;

            this.preloader = document.body.querySelector('#tarot_preloader');
            this.cardsRow = this.game.querySelector('.tarot-cards');
            this.tirage = this.game.querySelector('.tarot-tirage');
            this.cards = this.game.querySelectorAll('.tarot-card');
            this.collapsedElement = this.game.querySelectorAll('.tarot-content-tirage-wrap');
            this.optionContainer = this.game.querySelector('.tarot-game-options');
            this.optionBtns = this.optionContainer.querySelectorAll('.actions > a');

            this.attributes = JSON.parse(game.getAttribute('data-attributes'));

            if (!this.attributes) {
                throw 'Cannot parse attributes!'
            }

            this.attributes.cards_selected = {};
            this.attributes.new_game = true;

            if (!spTarotParams.game_result_page) {
                throw 'Result page not found!'
            }

            if (!this.cards) {
                throw 'No cards found!'
            }

            if (!this.tirage) {
                throw 'No tirage area found!'
            }

            if (this.cards.length < this.attributes.cards_count) {
                throw 'Cards are not enough!'
            }

            this.deckSetHeight();
            this.cardsRollHoriz();
            this.addPageTitleToAttrs();

            this.addEventListeners();
        } catch (e) {
            game.innerHTML = `<p class="danger">${e}<br />Try to refresh page!</p>`;
        }
    }

    addPageTitleToAttrs() {
        //We use it to set title on result page
        const pageTitle = document.querySelector('.tarot-block-slogan h1');
        if (pageTitle) {
            this.attributes.game_page_title = pageTitle.textContent;
        }
    }

    showPopup(popup = '') {
        popup = this.optionContainer.querySelector(popup);

        if (!popup) {
            return;
        }

        document.body.classList.add('modal-visible');
        this.optionContainer.style.display = 'flex';
        jQuery(popup).animate({
            top: '50%',
        }, 800);
    }

    addEventListeners() {
        let _this = this;

        this.cards.forEach(function (card) {
            card.addEventListener('click', function (e) {
                e.preventDefault();

                if (card.classList.contains('selected')) {
                    return;
                }

                if (_this.cardCurrent >= _this.attributes.cards_count) {
                    return;
                }

                _this.cardCurrent++;

                card.classList.add('selected');

                _this.cardsSelected.push(card);


                jQuery(_this.collapsedElement).slideDown(400, () => {
                    _this.game.parentElement.scrollIntoView({block: "start", behavior: "smooth"});
                    _this.cardMoveToPlace(card);
                });
            });
        });

        this.optionBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();

                _this.handleOptionBtn(e.currentTarget);
            }, /*{once: true}*/);
        });

        //Click on tirage
        this.tirage.addEventListener('click', function (e) {
            e.preventDefault();

            _this.showPopup('.tarot-hint');
        })

        //Update game height
        let resizeTimeout;
        window.addEventListener("resize", function () {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function () {
                    resizeTimeout = null;
                    _this.deckSetHeight();
                }, 100);
            }
        });
    }

    capitalize(word) {
        if (!word) {
            return '';
        }

        const lower = word.toLowerCase();
        return word.charAt(0).toUpperCase() + lower.slice(1);
    }

    handleOptionBtn(btn) {
        let _this = this;
        let step = btn.dataset.nextStep;
        let current = btn.closest('.tarot-game-popup');
        let option = btn.dataset.optionVal;
        let option_translated = btn.textContent.trim();
        let option_name = btn.dataset.optionName;
        const auto_fill_selector = btn.dataset.optionAutoFill;

        //Autofill needed elements
        this.fillElements(auto_fill_selector, option_name, option_translated);

        //Set predefined option
        if (option_name && option) {
            this.attributes[option_name] = option;
        }

        //Set game option
        if (option_name === 'form') {
            //Set option from form
            let inputs = current.querySelectorAll('.form .required');

            let errors = [];

            if (inputs.length) {
                inputs.forEach(function (input) {
                    input.classList.remove('error');
                    let name = input.getAttribute('name');
                    let val = input.type === 'checkbox' ? input.checked : input.value;

                    if (val) {
                        //Validate email
                        if (input.type === 'email' && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(val)) {
                            errors.push(input);
                        } else if (input.name === 'user_phone' && !/^0(1|2|3|4|5|6|7|9)\d{8}$/.test(val.replace(/\D+/, ''))) {
                            alert('Erreur dans votre numéro. Veuillez entrer un numéro francais de 10 chiffres.');
                            errors.push(input);
                        } else {
                            _this.attributes[name] = val;

                            //Save gamer email to cookie
                            _this.setCookie('tarot_' + name, val, {'max-age': 31556952}); //One year
                        }
                    } else {
                        errors.push(input);
                    }
                });

            }

            if (errors.length) {
                errors.forEach(function (error) {
                    error.classList.add('error');
                });

                return;
            }
        }

        if ('popup' === step) {
            let next = btn.dataset.nextPopup;

            jQuery(next).animate({
                top: '50%',
            }, 800);
        }

        jQuery(current).animate({
            top: '200%',
        }, 800, function () {

            if ('game' === step) {
                _this.game.parentElement.scrollIntoView({block: "start", behavior: "smooth"});
            }

            if ('result' === step) {
                _this.attributes.date = Math.floor(Date.now() / 1000); //Save game date
                _this.setCookie('tarot-result', JSON.stringify(_this.attributes), {'max-age': 86400}); //Save game result for a one day

                //Flip cards
                let total = 0;
                let timer = 100;
                _this.game.classList.add('all-selected');
                _this.cardsSelected.forEach(function (card, idx) {
                    total = total + timer;
                    setTimeout(function () {
                        card.classList.add('flip');
                    }, total);
                });

                //todo: recode timeout (maybe make promise after flipping cards)
                setTimeout(function () {
                    jQuery(_this.preloader).fadeIn(500, function () {
                        location.href = spTarotParams.game_result_page;
                    });
                }, total * 2 + 2500); //2500 (2.5 seconds) it's delay to have time to see result

            }

            //Hide option container
            if (['game', 'result', 'close'].indexOf(step) !== -1) {
                document.body.classList.remove('modal-visible');
                jQuery(_this.optionContainer).fadeOut();
            }
        });
    }

    fillElements(fill_selector, option_name, option_translated) {
        if (!fill_selector || !option_name || !option_translated) {
            return;
        }

        const auto_fill_elements = document.querySelectorAll(fill_selector);
        let auto_fill_option = this.capitalize(option_translated);
        switch (option_name) {
            case 'sub_theme':
                auto_fill_option = `(${auto_fill_option})`;
                break;
            default:
                auto_fill_option = auto_fill_option.toUpperCase();
        }

        auto_fill_elements.forEach((elem) => {
            elem.textContent = auto_fill_option;
        });
    }

    deckSetHeight() {
        let cardHeight = this.cards[0].offsetHeight;
        this.cardsRow.style.height = `${cardHeight}px`;
    }

    cardsRollHoriz() {
        let _this = this;
        let count = this.cards.length;
        let margin = (100 - this.width) / count;
        margin = margin + (margin / count)

        this.cards.forEach(function (card, idx) {
            jQuery(card).animate({
                left: (idx * margin) + '%',
            }, 800);
        });
    }

    /**
     * Gets computed translate values
     * @param {HTMLElement} element
     * @returns {Object}
     */
    getTranslateValues(element) {
        const style = window.getComputedStyle(element)
        const matrix = style['transform'] || style.webkitTransform || style.mozTransform

        // No transform property. Simply return 0 values.
        if (matrix === 'none' || typeof matrix === 'undefined') {
            return {
                x: 0,
                y: 0,
                z: 0
            }
        }

        // Can either be 2d or 3d transform
        const matrixType = matrix.includes('3d') ? '3d' : '2d'
        const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

        // 2d matrices have 6 values
        // Last 2 values are X and Y.
        // 2d matrices does not have Z value.
        if (matrixType === '2d') {
            return {
                x: parseFloat(matrixValues[4]),
                y: parseFloat(matrixValues[5]),
                z: 0
            }
        }

        // 3d matrices have 16 values
        // The 13th, 14th, and 15th values are X, Y, and Z
        if (matrixType === '3d') {
            return {
                x: parseFloat(matrixValues[12]),
                y: parseFloat(matrixValues[13]),
                z: parseFloat(matrixValues[14])
            }
        }
    }

    cardMoveToPlace(card) {
        let _this = this;
        let tirage = this.game.querySelector(`.place-${this.cardCurrent}`);

        if (!tirage) {
            console.error('Tirage palace not found!');
            return;
        }

        const translate = _this.getTranslateValues(tirage);

        let percentLeft = (tirage.offsetLeft + translate.x) / this.game.offsetWidth * 100;
        let percentTop = (tirage.offsetTop + translate.y) / this.game.offsetHeight * 100;

        jQuery(card).css('z-index', this.cardCurrent).animate({
            left: percentLeft + '%',
            top: percentTop + '%',
        }, 600, function () {
            tirage.classList.add('with-card');
            tirage.appendChild(card);
        });

        //prepare card data
        let cards_selected = {
            id: card.dataset.cardId,
            type: (Math.random() > 0.4) ? 'positive' : 'negative' //positive or negative
        };

        let tirage_label = tirage.querySelector('.tarot-tirage-label > span');

        if (tirage_label) {
            cards_selected.tirage_label = tirage_label.textContent;
        }

        if (_this.cardCurrent === 2) {
            if (card.dataset.cardReverse === '1') {
                cards_selected.type = 'positive'; //diablo/devil
            } else if (_this.attributes.cards_count === 5) { //Reverse second card for standard tirage
                cards_selected.type = 'negative';
            }
        }

        //Use forced card type (ambiance)
        if (card.dataset.cardType) {
            cards_selected.type = card.dataset.cardType;
        }

        card.classList.add(cards_selected.type);

        _this.attributes.cards_selected[_this.cardCurrent] = cards_selected;

        //Make all cards selected
        if (this.cardCurrent === this.attributes.cards_count) {
            setTimeout(function () {
                _this.cardsAllSelected();
            }, 1000);
        }
    }

    cardsAllSelected() {
        let _this = this;
        if (this.cardCurrent !== this.attributes.cards_count) {
            return;
        }

        //Show option container
        document.body.classList.add('modal-visible');
        jQuery(_this.optionContainer).fadeIn(0);

        //Show popup for selection theme
        let next_popup = '.tarot-option-theme';

        if (_this.attributes.theme) {
            next_popup = '.tarot-option-sex';

            //Show love popup if result needs love
            //todo: recode it better, maybe create some config
            if (['love', 'theme_from_each_card', 'all_themes_from_one_card', 'fixed_ambiance'].indexOf(_this.attributes.theme) !== -1 && !_this.attributes.sub_theme) {
                next_popup = '.tarot-option-love'; //Show sub theme popup for love if it is not predefined
            }
        }

        _this.showPopup(next_popup);
    }

    showResult() {
        let _this = this;
        if (!this.result) {
            return;
        }

        document.body.classList.add('has-tarot-result');

        this.tirage = this.tirage.cloneNode(true);
        this.result.querySelector('.tarot-result-tirage').appendChild(this.tirage);

        document.body.appendChild(this.result);

        setTimeout(function () {
            _this.result.classList.add('show');
        }, 500);
    }

    getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    setCookie(name, value, options = {}) {
        options = {
            path: '/',
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    deleteCookie(name) {
        this.setCookie(name, "", {
            'max-age': -1
        })
    }
}

class tarotGameResult {
    constructor() {
        this.addEventListeners();
        // this.initPopup();
    }

    addEventListeners() {
        //Scroll to card description (on result page)
        let result_tirage_cards = document.querySelectorAll('.tarot-result-tirage a.tarot-card');
        if (result_tirage_cards.length) {
            result_tirage_cards.forEach(function (card) {
                card.addEventListener('click', function (e) {
                    e.preventDefault();

                    let card_description = document.querySelector(card.getAttribute('href'));

                    if (card_description) {
                        card_description.scrollIntoView({block: "start", behavior: "smooth"});
                    }
                });
            });
        }

        let show_card_descr = document.querySelectorAll('.tarot-show-card-descr');
        if (show_card_descr.length) {
            show_card_descr.forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();

                    let parent = btn.closest('.tarot-card-descr-parent');

                    if (!parent) {
                        return;
                    }

                    let descr = parent.querySelector('.card-descr')
                    if (!descr) {
                        return;
                    }

                    jQuery(descr).slideToggle();
                });
            });
        }

    }

    initPopup() {
        this.optionContainer = document.getElementById('tarot-game-result-options');
        this.popup = document.querySelector('#tarot-game-result-options .tarot-game-result-subscribe');

        if (!this.optionContainer || !this.popup) {
            return;
        }

        this.actionBtns = document.querySelectorAll('.game-result-action-element');
        this.tirageBtns = document.querySelectorAll('.tarot-result-tirage-btns > a');

        //Open Popups
        this.tirageBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();

                //Set needed link to the action buttons
                this.actionBtns.forEach((actionBtn) => {
                    actionBtn.href = btn.href;
                });

                this.showPopup();
            });
        });

        //Action buttons
        this.actionBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                if (event.target !== event.currentTarget) {

                    return; //Exit if it was clicked in some parent element
                }

                event.preventDefault();
                const type = btn.dataset.type;

                if ('cancel' === type) {
                    location.href = btn.href;
                }

                if ('send' === type) {
                    jQuery.ajax({
                        type: 'POST',
                        url: spTarotParams.ajaxUrl,
                        data: jQuery(btn.closest('form')).serialize(),
                    }).always(function () {
                        location.href = btn.href;
                    });
                }

                this.optionContainer.style.display = 'none';
            });
        });
    }

    showPopup() {
        document.body.classList.add('modal-visible');
        this.optionContainer.style.display = 'block';
    }

    closePopup(){
        document.body.classList.remove('modal-visible');
        this.optionContainer.style.display = 'none';
    }
}

class tarotSite {
    constructor() {
        this.slidersInit();
        this.spoilerInit();

        if (document.querySelector('.tarot-result-tirage-sidebar')) {
            new StickySidebar('.tarot-result-tirage-sidebar', {
                topSpacing: 50,
                bottomSpacing: 0,
                minWidth: 980,
                containerSelector: '.tarot-block-game-result',
                innerWrapperSelector: '.tarot-result-tirage-inner'
            });
        }
    }

    spoilerInit() {
        jQuery('.tarot-block-spoiler-item .menu-item').on('click', function (e) {
            e.preventDefault();

            let $self = jQuery(this);
            let $plus = $self.find('.ico-plus');
            let $minus = $self.find('.ico-minus');
            let $content = $self.next('.spoiler-content');

            $plus.toggle();
            $minus.toggle();
            $content.slideToggle();
        });
    }

    slidersInit() {
        let sliders = document.querySelectorAll('.tarot-slider');

        if (!sliders.length) {
            return;
        }

        sliders.forEach(function (slider) {
            imagesLoaded(slider, function () {
                tns({
                    container: slider,
                    items: 4,
                    slideBy: 1,
                    gutter: 20,
                    autoplay: true,
                    autoplayButtonOutput: false,
                    nav: false,
                    controlsText: [
                        '<svg viewBox="0 0 443.52 443.52"><use xlink:href="#tarot_ico_arrow_left_alt"></use></svg>',
                        '<svg viewBox="0 0 443.52 443.52"><use xlink:href="#tarot_ico_arrow_right_alt"></use></svg>',
                    ],
                    responsive: {
                        1200: {
                            items: 4
                        },
                        981: {
                            items: 3
                        },
                        768: {
                            items: 2
                        },
                        1: {
                            items: 1
                        }
                    }
                });

                jQuery(slider).fadeIn(500);
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let games = document.querySelectorAll('.tarot-game');

    setTimeout(function () {
        games.forEach(function (game) {
            new tarotGame(game);
        });

        new tarotGameResult();

        new tarotSite();

        //Hide loader if needed
        let preloader = document.body.querySelector('#tarot_preloader');

        jQuery(preloader).fadeOut(500);
    }, 500);
});

function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}